export const setBotRegistrationFormIsOpen = (state, action) => {
  state.botRegistrationFormIsOpen = action.payload
}
